import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71989192"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "color-red"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormFieldRecommendedLengthInput = _resolveComponent("FormFieldRecommendedLengthInput")!
  const _component_EditIcon = _resolveComponent("EditIcon")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Page = _resolveComponent("Page")!

  return (_openBlock(), _createBlock(_component_Page, {
    title: "SEO Поля",
    "header-buttons": [
      {
        text: 'Создать категорию',
        href: _ctx.getCategoryFormUrl({ categoryId: 'create' }),
      },
    ]
  }, {
    content: _withCtx(() => [
      _createVNode(_component_DataTable, {
        "column-defs": _ctx.columnDefs,
        "row-data": _ctx.rowData,
        loading: _ctx.isRowDataLoading,
        "error-message": _ctx.errorMessage,
        "search-query": _ctx.searchQuery,
        pagination: {
          pageNumber: _ctx.pageNumber,
          pageCount: _ctx.pageCount,
          disabled: _ctx.isRowDataLoading,
        },
        onChange: _ctx.handleChange
      }, {
        "cell(page-title)": _withCtx(({ row, rowIndex }) => [
          (_ctx.values[rowIndex])
            ? (_openBlock(), _createBlock(_component_FormFieldRecommendedLengthInput, {
                key: 0,
                value: _ctx.values[rowIndex].pageTitle,
                "onUpdate:value": ($event: any) => ((_ctx.values[rowIndex].pageTitle) = $event),
                name: "pageDescription",
                type: "textarea",
                min: 50,
                max: 60,
                onBlur: ($event: any) => (
              _ctx.updateSeo(
                row.id,
                _ctx.values[rowIndex].pageTitle,
                _ctx.values[rowIndex].pageDescription
              )
            )
              }, null, 8, ["value", "onUpdate:value", "onBlur"]))
            : _createCommentVNode("", true)
        ]),
        "cell(page-description)": _withCtx(({ row, rowIndex }) => [
          (_ctx.values[rowIndex])
            ? (_openBlock(), _createBlock(_component_FormFieldRecommendedLengthInput, {
                key: 0,
                value: _ctx.values[rowIndex].pageDescription,
                "onUpdate:value": ($event: any) => ((_ctx.values[rowIndex].pageDescription) = $event),
                name: "pageDescription",
                type: "textarea",
                min: 115,
                max: 165,
                onBlur: ($event: any) => (
              _ctx.updateSeo(
                row.id,
                _ctx.values[rowIndex].pageTitle,
                _ctx.values[rowIndex].pageDescription
              )
            )
              }, null, 8, ["value", "onUpdate:value", "onBlur"]))
            : _createCommentVNode("", true)
        ]),
        "cell(content)": _withCtx(({ row }) => [
          (row.contentSymbolsCount && row.contentWordsCount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", null, _toDisplayString(`${row.contentSymbolsCount} символов,`), 1),
                _createElementVNode("div", null, _toDisplayString(`${row.contentWordsCount} слов`), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, "-"))
        ]),
        "cell(actions)": _withCtx(({ row }) => [
          _createVNode(_component_BaseButton, {
            variant: "icon",
            title: "Edit",
            href: _ctx.getCategoryFormUrl({ categoryId: row.id })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_EditIcon)
            ]),
            _: 2
          }, 1032, ["href"])
        ]),
        _: 1
      }, 8, ["column-defs", "row-data", "loading", "error-message", "search-query", "pagination", "onChange"])
    ]),
    _: 1
  }, 8, ["header-buttons"]))
}